import AppConfirm from '@/components/App/AppConfirm.vue'

const Confirm = {
  install(Vue) {
    this.EventBus = new Vue()
    Vue.component('app-confirm', AppConfirm)
    Vue.prototype.$confirm = {
      show(params) {
        Confirm.EventBus.$emit('show', params)
      }
    }
  }
}

export default Confirm